import BaseObject from "@shared/BaseObject.js";

export default class BaseToolEmbedSettings extends BaseObject {
	isEnabled: boolean = false
	allowedDomains: string[] = []
	returnUrl: string = ""
	embeddedUrl: string = ""

	constructor(options = {}) {
		super(options);
		this.applyOptions(options)
	}
}
